import { Spacer } from './ColorPreview';
import { Column, Font, PrimaryButton, Row } from './DesignSystem';
import { Palette } from './Palette';

type SubscriptionTierItem = {
  description: string;
};
type SubscriptionTierProps = {
  name: string;
  price: string;
  items: Array<SubscriptionTierItem>;
};

function SubscriptionTier({ name, price, items }: SubscriptionTierProps) {
  return (
    <Column
      style={{ backgroundColor: 'white', height: '244px', width: '196px' }}
    >
      <Row
        style={{ alignItems: 'center', width: '100%', backgroundColor: 'blue' }}
      >
        <div>
          <Font kind="font-body">{name}</Font>
        </div>
        <div>
          <Font kind="font-body">$ {price}/month</Font>
        </div>
      </Row>

      {items.map((i) => {
        return (
          <div key={i.description}>
            <Font kind="font-body">{i.description}</Font>
          </div>
        );
      })}

      <Spacer />

      <PrimaryButton
        style={{ marginBlockEnd: 8 }}
        text={`Upgrade to ${name}`}
        onClick={() => {
          // TODO: Clicky
        }}
      />
    </Column>
  );
}

export function SubscriptionsPalette({}) {
  return (
    <Palette title="Subscriptions" windowID="subscriptions">
      <Row style={{ gap: 16 }}>
        <SubscriptionTier
          name="Core"
          price="20"
          items={[
            {
              description: 'Everything in Free and',
            },
            {
              description: '1-click App Store Submission',
            },
          ]}
        />
        <SubscriptionTier name="Core" price="20" items={[]} />
        <SubscriptionTier name="Core" price="20" items={[]} />
      </Row>
    </Palette>
  );
}
